/**
 * Created by Andrey Popov on 15.10.2026
 */

const NoFillWindowView = Prefab.createWindow("nofillwindow", "nofillwindow_prefab_json", {
    closeByHardwareBackButton: false,
    bundles: ["nofillwindow_games"]
});

// stands in for an external rewarded ad: our games take turns on the banner, the next one at every showing
const NoFillWindow = function (onReward) {
    const game = NoFillWindow.nextGame();
    NoFillWindow.logEvent(cleverapps.EVENTS.NOFILL_SHOWN, game);
    return new NoFillWindowView(onReward, game);
};

NoFillWindow.shown = 0;

// the games with a banner, those the platform can switch to first; with none of them the banners still rotate and Play does nothing
NoFillWindow.nextGame = function () {
    const games = Object.keys(bundles.nofillwindow_games.frames).filter((game) => game !== cleverapps.config.name).sort();
    const promotable = games.filter((game) => NoFillWindow.getPromotion(game));
    const pool = promotable.length ? promotable : games;
    const game = pool[NoFillWindow.shown % pool.length];
    NoFillWindow.shown += 1;
    return game;
};

NoFillWindow.logEvent = function (event, game) {
    cleverapps.metrics.logEvent(event, { itemId: game });
};

// the cross promo's link and payload, the test stand's sibling game included; nothing where the platform has no way to the game
NoFillWindow.getPromotion = function (game) {
    return cleverapps.crossPromo && cleverapps.crossPromo.createPromotion(game);
};

NoFillWindow.play = function (game) {
    NoFillWindow.logEvent(cleverapps.EVENTS.NOFILL_PLAY, game);

    const promotion = NoFillWindow.getPromotion(game);
    if (promotion) {
        connector.platform.switchGame(promotion.link, promotion.payload);
    }
};

VipAdsAdapter.prototype.createWindow = function (onReward) {
    if (cleverapps.abExperiments.getGroup(ABExperiments.Tests.nofillwindow) === "A") {
        new NoFillWindow(onReward);
    } else {
        new VIPRewardedWindow(onReward);
    }
};
